import React from 'react';
import classNames from 'classnames';
import CompanyInputs from 'components/CompanyInputs';

import './Company.styles.scss';
import './Company.styles.responsive.scss';

type CompanyProps = {
  className?: string;
};

const Company: React.FC<CompanyProps> = (props) => {
  const { className, children } = props;

  const classes = classNames(
    'company-page',
    'profile-card-container',
    className,
  );

  return (
    <div className={classes}>
      <CompanyInputs>{children}</CompanyInputs>
    </div>
  );
};

export default Company;
